export default __webpack_public_path__ + "static/media/info-circle.8e64075b.svg";